export default __webpack_public_path__ + "static/lock-screen-5f1c31fb3b1d3d689396757fb1f683d2.webp";